<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView v-slot="{ Component }">
    <Transition name="page" mode="out-in">
      <component :is="Component" />
    </Transition>
  </RouterView>
</template>

<style scoped>
/* Sayfa geçişi kasten silik: finansal bir arayüzde animasyon dikkat çekmemeli,
   yalnızca bağlam değişimini yumuşatmalı. */
.page-enter-active,
.page-leave-active {
  transition: opacity var(--nk-motion-duration-fast) var(--nk-motion-easing-standard);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .page-enter-active,
  .page-leave-active {
    transition: none;
  }
}
</style>
